export function sleep(msec: number, result = true){
  return new Promise(resolve=>{
    setTimeout(()=>resolve(result), msec)
  })
}